import React, { Component, Fragment } from "react";
import Prazo from "../../../Components/Admin/Prazo";

export default class PageAdminPrazo extends Component {
    render() {
        return (
            <Fragment>
                <Prazo />
            </Fragment>
        );
    }
}
